module.exports = __webpack_public_path__ + "static/media/iconLogout.1e33f5d0.svg";